import React from "react";
import { Link } from "gatsby";
import logo from "../img/oberlin.svg";
import messages from '../data/navbar'
import SelectLanguage from './SelectLanguage'

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: "",
      fontDarkActiveClass: "",
    };
    this.language = Object.keys(messages).includes(props.language) ? props.language : "en"; // default language is english
    this.sitePath = props.sitePath;
  }

  toggleHamburger() {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
            navBarActiveClass: "is-active",
            fontDarkActiveClass: "has-dark-font",
          })
          : this.setState({
            navBarActiveClass: "",
            fontDarkActiveClass: "",
          });
      }
    );
  }

  render() {
    /// i18n language setting links handling, not really nicely done...
    let langsMenu = {}
    let key = ""
    for (let keyVar of Object.keys(messages[this.language])) {
      if (this.sitePath.pathname.includes(keyVar)) {
        key = keyVar
        break
      }
    }
    const icon = messages[this.language]["otherLanguageIcon"];
    key = (key === "") ? "index" : key
    langsMenu = Object.keys(messages).map((lang) => ({ langKey: lang, selected: this.language === lang, link: messages[lang][key].href, icon: icon }))
    let homePageLink = messages[this.language]["index"].href


    return (
      <nav
        className="navbar is-transparent sticky"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to={homePageLink} className="navbar-item" title="Logo">
              <img src={logo} alt="Oberlin" style={{ width: "88px" }} />
            </Link>
            {/* Hamburger menu */}
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              role="menuitem"
              tabIndex={0}
              onKeyPress={() => this.toggleHamburger()}
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered">
              <Link className={`navbar-item ${this.state.fontDarkActiveClass}`} to={messages[this.language]['choirleader'].href}>
                {messages[this.language]['choirleader'].name}
              </Link>
              <Link className={`navbar-item ${this.state.fontDarkActiveClass}`} to={messages[this.language]['arrangements'].href}>
                {messages[this.language]['arrangements'].name}
              </Link>
              <Link className={`navbar-item ${this.state.fontDarkActiveClass}`} to={messages[this.language]['vocalcoach'].href}>
                {messages[this.language]['vocalcoach'].name}
              </Link>
              <Link className={`navbar-item ${this.state.fontDarkActiveClass}`} to={messages[this.language]['contact'].href}>
                {messages[this.language]['contact'].name}
              </Link>
            </div>
            <div className="has-text-centered">
              <SelectLanguage langs={langsMenu} />
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
